import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

export default withStyles({
  root: {
    alignItems: 'flex-start',
    display: 'flex',
  },
})(Grid);
